import { FormProvider } from 'react-hook-form';
import { useCreateClientContractTermForm } from './hooks';
import { CreateClientContractTermFormPresentation } from './presentations';

/**
 * 企業契約期間 新規作成 Container
 *
 * - FormProvider でフォームコンテキストを提供し、Presentation 内の Controller が参照する
 */
export const CreateClientContractTermForm: React.FC = () => {
  const {
    state: { methods, isMutating, handleSearchClients, handleSearchContractPlans },
    actions: { handleSubmit, handleCancel },
  } = useCreateClientContractTermForm();

  return (
    <FormProvider {...methods}>
      <CreateClientContractTermFormPresentation
        searchAction={handleSearchClients}
        contractPlanSearchAction={handleSearchContractPlans}
        isButtonDisabled={isMutating}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </FormProvider>
  );
};
